module.exports = __webpack_public_path__ + "img/paymentcard.b6936a12.svg";